/**
 * Format a date as DD.MM.YYYY with leading zeros
 * @param {Date|string} dateInput - Date object or date string
 * @returns {string} Formatted date string
 */
export const formatDate = (dateInput) => {
  if (!dateInput) return 'N/A';
  
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  
  // Check if date is valid
  if (isNaN(date.getTime())) return 'N/A';
  
  // Get day, month, and year with leading zeros
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  
  return `${day}.${month}.${year}`;
};

/**
 * Format a timestamp as DD.MM.YYYY, HH:MM:SS with leading zeros
 * @param {Date|string} dateInput - Date object or date string
 * @returns {string} Formatted timestamp string
 */
export const formatTimestamp = (dateInput) => {
  if (!dateInput) return 'N/A';
  
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  
  // Check if date is valid
  if (isNaN(date.getTime())) return 'N/A';
  
  // Get date components with leading zeros
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  
  // Get time components with leading zeros
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${day}.${month}.${year}, ${hours}:${minutes}:${seconds}`;
};

/**
 * Format a date range as DD.MM.YYYY - DD.MM.YYYY
 * @param {Date|string} startDate - Start date object or date string
 * @param {Date|string} endDate - End date object or date string
 * @returns {string} Formatted date range string
 */
export const formatDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) return 'N/A';
  
  return `${formatDate(startDate)} - ${formatDate(endDate)}`;
};
